import { computed, defineAsyncComponent, type ComputedRef, type Component } from 'vue'

// Assume icons is populated as before
const icons: Record<string, () => Promise<any>> = import.meta.glob(`../assets/svgs/**/*.svg`)

export interface useIconsModule {
  icons: Record<string, () => Promise<unknown>>
  icon: ComputedRef<Component | null>
}

export const useIcons: (path: string) => useIconsModule = (path: string) => {
  // Function to load the SVG component, or return null if not found
  const loadSvgComponent = (path: string) => {
    // Check if the icon exists in the icons map
    const loader = icons[`../assets/svgs/${path}.svg`]
    if (loader) {
      // If the icon loader function exists, try to define the async component
      return defineAsyncComponent(async () => {
        try {
          const component = await loader()
          return component
        } catch (error) {
          console.error(`Failed to load icon: ${path}`, error)
          return null // Return null if the component failed to load
        }
      })
    } else {
      // If the loader function doesn't exist, log and return null immediately
      console.warn(`Icon not found: ${path}`)
      return null
    }
  }

  return {
    icons,
    icon: computed(() => loadSvgComponent(path))
  }
}
